import React, { FC } from 'react';
import { useGetUserNotificationsCount } from 'memberPortalApi/userNotification.api';
import useMenuState from 'common/hooks/useMenuState';
import UserNotificationsBtn from 'components/Header/components/UserNotificationsBtn';
import MemberPortalUserNotificationsContentProvider from 'components/Header/components/MemberPortalUserNotificationsContentProvider';

const MemberPortalUserNotificationsContainer: FC = () => {
  const { menuAnchorEl, handleShowMenu, handleCloseMenu } = useMenuState();
  const { data } = useGetUserNotificationsCount();

  return (
    <>
      <UserNotificationsBtn onClick={handleShowMenu} count={data} />

      {menuAnchorEl ? (
        <MemberPortalUserNotificationsContentProvider
          menuAnchorEl={menuAnchorEl}
          onClose={handleCloseMenu}
        />
      ) : null}
    </>
  );
};

export default MemberPortalUserNotificationsContainer;
